import { PortalBaseService } from 'src/portal/portal-base.service';
import { PortalCredentialGroupResultModel } from './credentials.models';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CredentialsService extends PortalBaseService {
  public getLicenses(): Promise<PortalCredentialGroupResultModel[]> {
    return this.get<PortalCredentialGroupResultModel[]>('portal/credentials').toPromise();
  }
}
